import React from 'react';
import PropTypes from 'prop-types';
import { format } from '@breezeway/brzw-react-core';

const DateTimeCell = props => (
  <div className="rt-td--default">
    <span>{format.datetime.formatDateTime(props.value, true, 'MMM D, YYYY [at] h:mma')}</span>
  </div>
);

DateTimeCell.propTypes = {
  value: PropTypes.string,
};

export default DateTimeCell;
